import { Cable, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { eur, quoteTotals, cablingPct, CABLING } from "@/lib/pricing";

export const CablingRow = ({ q, update }) => {
  const t = quoteTotals(q);
  return (
    <section className="bg-slate-900 border border-slate-800 rounded-lg p-4 grid grid-cols-2 sm:grid-cols-[1fr_auto_auto] gap-3 items-center" data-testid="cabling-row">
      <div className="col-span-2 sm:col-span-1 flex items-center gap-2 min-w-0">
        <Cable className="h-5 w-5 text-sky-400 shrink-0" />
        <span className="font-medium sm:truncate">{CABLING}</span>
        <Lock className="h-3.5 w-3.5 text-slate-500 shrink-0" aria-label="Voce fissa" />
      </div>
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <Input type="number" min={0} max={100} step="0.5" value={cablingPct(q)} aria-label="Percentuale cablaggi"
          onChange={(e) => update({ cabling_pct: Math.min(Math.max(+e.target.value || 0, 0), 100) })} className="h-8 w-20 font-mono" data-testid="cabling-pct-input" />
        <span className="whitespace-nowrap">% di {eur(t.baseMat)}</span>
      </div>
      <span className="text-right font-mono" data-testid="cabling-amount">{eur(t.cablaggi)}</span>
    </section>
  );
};
